import { combineReducers } from '@reduxjs/toolkit';
import datapoints from './datapoints';
import pagination from './pagination';

const root = combineReducers({ datapoints, pagination });

export default root;
